function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { useContext } from 'react';
import { func, node } from 'prop-types';
import { useTranslation } from 'react-i18next';
import SaveButton from '../SaveButton/index.jsx';
import FormContext from '../../context/FormContext.js';

/**
 * FormSubmitButton component.
 */
const FormSubmitButton = ({
  onClick,
  children,
  ...restProps
}) => {
  const {
    formRef
  } = useContext(FormContext);
  const {
    t
  } = useTranslation();
  const submit = async evt => {
    const {
      current: formEl
    } = formRef;
    evt.preventDefault();
    if (onClick) {
      await onClick();
    }

    // Listen for our custom `submitted` event and resolve or reject accordingly
    return new Promise((resolve, reject) => {
      const submitEvt = new Event('submit', {
        cancelable: true,
        bubbles: true
      });

      // Adds a custom event listener to the form
      const listener = formEl.addEventListener('submitted', ({
        detail: success
      }) => {
        formEl.removeEventListener('submitted', listener);
        if (!success) {
          reject();
          return;
        }
        resolve();
      }, false);
      formRef.current.dispatchEvent(submitEvt);
    });
  };
  return /*#__PURE__*/React.createElement(SaveButton, _extends({}, restProps, {
    type: "submit",
    onClick: submit,
    buttonStates: {
      default: {
        text: children,
        icon: null
      },
      saving: {
        text: t('molecules.formSubmitButton.button.savingText'),
        icon: 'kebab-h'
      },
      saved: {
        text: t('molecules.formSubmitButton.button.savedText'),
        icon: 'tick'
      }
    }
  }));
};
FormSubmitButton.defaultProps = {
  onClick: null
};
FormSubmitButton.propTypes = process.env.NODE_ENV !== "production" ? {
  /** On click event handler, fired before the form is submitted. */
  onClick: func,
  /** Children to use as the initial button state. */
  children: node.isRequired
} : {};
export default FormSubmitButton;